export default "__VITE_ASSET__DlxzUKGq__"